import colors from "shared/styles/colors"
import { ThemeType } from "shared/styles/theme"
import styled from "styled-components"
import theme from "styled-theming"

export const DiffHeader = styled.div`
    position: absolute;
    z-index: 10;
    border-radius: 5px;
    padding: 10px;
    opacity: 0.7;
    max-width: 49%;
    word-wrap: break-word;
    &.right {
        right: 15px;
    } 
    &.left {
        left: 15px;
    }
`

export const DiffProcessName = styled.h1``

const elementChangedFill = theme("mode", {
    [ThemeType.light]: colors.orangeBackground,
    [ThemeType.dark]: colors.orangeSecondary
})

const elementAddedFill = theme("mode", {
    [ThemeType.light]: colors.greenBackground,
    [ThemeType.dark]: colors.greenSecondary
})

const elementRemovedFill = theme("mode", {
    [ThemeType.light]: colors.warningBackground,
    [ThemeType.dark]: colors.warningDark3
})

export const DiffContainer = styled.div`
    position: absolute;
    top: 50px;
    bottom: 50px;
    left: 0;
    right: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    .di-container.left {
        border-right: dotted 2px #CCC;
    }
    .diff-changed:not(.djs-connection) .djs-shape:not(.djs-frame) .djs-visual > :nth-child(1):not(text) {
        fill: ${elementChangedFill} !important;
    }
    .diff-changed.djs-connection .djs-visual > :nth-child(1) {
        stroke: ${colors.orangeSecondary} !important;
    }
    .diff-removed:not(.djs-connection) .djs-visual > :nth-child(1) {
        fill: ${elementRemovedFill} /* light-red */ !important;
    }
    
    .diff-removed.djs-connection .djs-visual > :nth-child(1) {
        stroke: ${colors.warningDark} /* red */ !important;
    }
    
    .marker.marker-removed {
        background: ${colors.warningDark};
    }
    
    .diff-added:not(.djs-connection) .djs-visual > :nth-child(1) {
        fill: ${elementAddedFill} /* light-green */!important;
    }
    
    .diff-added.djs-connection .djs-visual > :nth-child(1) {
        stroke: ${colors.uiGreen} /* green */ !important;
    }
    
    .marker.marker-added {
        background: ${colors.uiGreen} /* green */;
    }
    
    .diff-layout-changed:not(.djs-connection) .djs-visual > :nth-child(1) {
        stroke: ${colors.blueSecondary} /* light-blue */ !important;
    }
    
    .diff-layout-changed.djs-connection .djs-visual > :nth-child(1) {
        stroke: ${colors.bluePrimary} /* blue */ !important;
    }
    
    .marker.marker-layout-changed {
        background: ${colors.bluePrimary} /* blue */;
    }
    .djs-shape.highlight .djs-outline {
        stroke: ${colors.orangePrimary} !important;
        stroke-width: 10px;
        fill: ${colors.orangePrimary};
    }
      /**
   * markers
   */
    .marker {
        border-radius: 50%;
        background-color: ${colors.grey_2};
        color: white;
        font-weight: bold;
        font-size: 150%;
        padding-right: 6px;
        padding-left: 6px;
    }
    
    .marker-changed {
        font-size: 130%;
        padding: 2px 5px;
    }
    
    .marker-layout-changed {
        font-size: 120%;
        padding: 2px 4px;
    }
`